import { render } from "./MathLevelView.vue?vue&type=template&id=48ab9dc2&ts=true"
import script from "./MathLevelView.vue?vue&type=script&lang=ts"
export * from "./MathLevelView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__